import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.Assessment = class Assessment extends AssessmentBuilder.Models.Base {
  defaults() {
    return {
      title: "",
      identifier: "",
      intro: new AssessmentBuilder.Models.Intro(),
      contentPosition: "right",
      submitterInfo: new AssessmentBuilder.Models.SubmitterInfo(),
      questions: new AssessmentBuilder.Collections.Questions(),
      completionPages: new AssessmentBuilder.Collections.CompletionPages(),
      scoring: "disabled",
      hcmacid: null,
      image: null,
    };
  }
};

AssessmentBuilder.Models.Assessment.prototype.relations = [
  {
    type: Backbone.HasOne,
    key: "intro",
    relatedModel: "AssessmentBuilder.Models.Intro",
  },
  {
    type: Backbone.HasMany,
    key: "questions",
    relatedModel: "AssessmentBuilder.Models.Question",
    collectionType: "AssessmentBuilder.Collections.Questions",
    reverseRelation: {
      key: "assessment",
      includeInJSON: false,
    },
  },
  {
    type: Backbone.HasMany,
    key: "completionPages",
    relatedModel: "AssessmentBuilder.Models.CompletionPage",
    collectionType: "AssessmentBuilder.Collections.CompletionPages",
    reverseRelation: {
      key: "assessment",
      includeInJSON: false,
    },
  },
  {
    type: Backbone.HasOne,
    key: "submitterInfo",
    relatedModel: "AssessmentBuilder.Models.SubmitterInfo",
  },
];

AssessmentBuilder.Models.Assessment.initializeRelations();
